// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_app_ai_tutor_description = /** @type {(inputs: {}) => string} */ () => {
	return `Learn Japanese with an AI tutor that customizes lessons based on your`
};

const id_app_ai_tutor_description = /** @type {(inputs: {}) => string} */ () => {
	return `Pelajari bahasa Jepang dengan tutor AI yang menyesuaikan pelajaran berdasarkan kebutuhan Anda`
};

const ja_app_ai_tutor_description = /** @type {(inputs: {}) => string} */ () => {
	return `あなたの学習状況に基づいてレッスンをカスタマイズするAI講師と一緒に日本語を学びましょう`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const app_ai_tutor_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.app_ai_tutor_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("app_ai_tutor_description", locale)
	if (locale === "en") return en_app_ai_tutor_description(inputs)
	if (locale === "id") return id_app_ai_tutor_description(inputs)
	return ja_app_ai_tutor_description(inputs)
};
export { app_ai_tutor_description as "app.ai_tutor_description" }